// 住所から緯度・経度を出す（仕様書「配送指示の入力」の「行き先の場所」）。送るのは住所だけ（名前・電話・メモは送らない）。
// Google のキーがあれば Google、なければ国土地理院の住所検索（キー不要・無料）を使う
const KEY = import.meta.env.VITE_GOOGLE_MAPS_KEY as string | undefined;

export type Geo = { lat: number; lng: number; label: string };

export async function geocode(address: string): Promise<Geo | null> {
  const q = address.trim();
  if (!q) return null;
  if (KEY) {
    const r = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?language=ja&region=jp&address=${encodeURIComponent(q)}&key=${KEY}`);
    const j = (await r.json()) as { results?: { formatted_address: string; geometry: { location: { lat: number; lng: number } } }[] };
    const g = j.results?.[0];
    return g ? { ...g.geometry.location, label: g.formatted_address } : null;
  }
  const r = await fetch(`https://msearch.gsi.go.jp/address-search/AddressSearch?q=${encodeURIComponent(q)}`);
  const j = (await r.json()) as { geometry: { coordinates: [number, number] }; properties: { title: string } }[];
  const g = Array.isArray(j) ? j[0] : undefined;
  return g ? { lng: g.geometry.coordinates[0], lat: g.geometry.coordinates[1], label: g.properties.title } : null;
}
